import PageTitle from "../../components/PageTitle";
import Tx from "../../components/Tx";
import IconBtn from "../../components/IconBtn";
import { useEffect, useState } from "react";
import DistributorDialog from '../../components/dialogs/DistributorDialog';
import { api } from "../../maps/data.js";
import Table from '../../components/Table';
import DistributorAddUsersDialog from '../../components/dialogs/DistributorAddUsersDialog';

function DistributorsPage() {

    const [opend, s_opend] = useState(false);
    const [open_distributor_user_d, s_open_distributor_user_d] = useState(false);
    const [distributors, s_distributors] = useState([]);
    const [distributor_obj_for_add, s_distributor_obj_for_add] = useState();

    const get = async () => {
        const distributors_res = await api({
            type: 'getDistributors',
            data: {
                withUsers: true
            }
        });
        s_distributors(distributors_res.map(d => ({...d, collapseData: d.users.map(u => ({...u, role: <Tx>{`user.add.${u.role}`}</Tx>}))})));
    }

    useEffect(() => {
        get();
    }, []);

    return (
        <div style={{ height: '100%', overflowY: 'scroll', padding: 20 }}>
            <PageTitle>
                <Tx>page.distributors.title</Tx>
                <IconBtn
                    style={{ position: 'absolute', right: 20 }}
                    onClick={() => s_opend({})}
                >
                    add
                </IconBtn>
            </PageTitle>
            <Table
                collapse={true}
                collapseComponent={Table}
                collapseProps={{
                    headers: [
                        { label: <Tx>user.table.name</Tx>, field: 'name' },
                        { label: <Tx>user.table.email</Tx>, field: 'email' },
                        { label: <Tx>user.table.role</Tx>, field: 'role' },
                    ]
                }}
                collapseStyle={{margin: '20px 0'}}
                collapseChildren="edit"
                data={distributors}
                headers={[
                    { label: <Tx>user.distributor.name</Tx>, field: 'name' },
                ]}
                actions={[
                    {
                        icon: 'addPerson',
                        action: item => {
                            s_open_distributor_user_d(true);
                            s_distributor_obj_for_add(item);
                        }
                    },
                    {
                        icon: 'edit',
                        action: item => s_opend(item)
                    }
                ]}
            />
            {
                opend && <DistributorDialog open={opend} onClose={() => { get(); s_opend(false) }} />
            }
            {
                open_distributor_user_d && <DistributorAddUsersDialog
                    distributor={distributor_obj_for_add}
                    open={open_distributor_user_d}
                    onClose={() => { get(); s_open_distributor_user_d(false) }}
                />
            }
        </div>
    )
}

export default DistributorsPage;